module.exports = __webpack_public_path__ + "static/media/visa.7f0b81f2.svg";